import React from 'react';
import { ICardProps } from '../../constants/commonTypes';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { WHITE, CARD_SHADOW } from '../../constants/constants';


const useStyles = makeStyles((_theme) => ({
  cardContainer: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: WHITE,
    boxShadow: `0 0 8px ${CARD_SHADOW}`,
    borderRadius: `0.5em`,
    opacity: `1`,
    width: '100%',
    margin: `0.5em 0`,
  },
}));

const Card = (props: ICardProps) => {

  const { children } = props;
  const classes = useStyles();

  return (
    <React.Fragment>
      <div className={classes.cardContainer}>
        {children}
      </div>
    </React.Fragment>
  )
}

Card.propTypes = {
  children: PropTypes.node,
}

export default Card;
